// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
  "version": "1.3.2",
  "hash": "g0385be6"
};
/* tslint:enable */
